import type { InjectionKey } from 'vue'

// Lets a placement hold its cookieless render instead of swapping to the real
// TrustBox. Provided by the surface that owns the design; blocks reach it
// through the generic content area, which forwards no props of its own.
const KEY: InjectionKey<boolean> = Symbol('trustpilot-always-cookieless')

export function provideTrustpilotAlwaysCookieless(value: boolean) {
  provide(KEY, value)
}

export function useTrustpilotAlwaysCookieless(): boolean {
  return inject(KEY, false)
}
